import callAPI from '../../../../../API/callSecureAPI'
import endpoints from '../../../../../API/endpoints'
import { useAuth0 } from '../../../../../contexts/auth0-context'
import { useMutation, useQueryClient } from 'react-query'
import { getTppCellsQueryKey } from '../../../../../components/TppView/hooks/useTppData'
import { useState } from 'react'
import { TppCell } from '../../../../../components/TppView/types'
import { useInvalidateTPPChangeLogQuery } from '../../../../../components/TPPChangeLog/queries/useInvalidateTPPChangeLogQuery'

type ToggleTPPCellLockPayload = {
    cellId: string
    tppId: string
}

type UseToggleTPPCellLockMutationProps = {
    onSuccess?: () => void
}

export const useToggleTPPCellLockMutation = ({ onSuccess }: UseToggleTPPCellLockMutationProps = {}) => {
    const [controller, setController] = useState<AbortController | null>(null)

    const { getTokenSilently } = useAuth0()
    const queryClient = useQueryClient()
    const { invalidateTPPChangeLogQuery } = useInvalidateTPPChangeLogQuery()

    const toggleTPPCellLock = async ({ cellId, tppId }: ToggleTPPCellLockPayload) => {
        try {
            console.log('Toggling lock for cellId:', cellId)
            if (controller) {
                controller.abort()
                setController(null)
            }

            const abortController = new AbortController()
            setController(abortController)

            const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })

            const { url, method } = endpoints.lockTPPCell
            const response = await callAPI(`${url}/${cellId}/lock`, method, token, undefined, {
                signal: abortController.signal,
            })

            return response.data
        } catch (e) {
            console.error(e)
            throw e
        }
    }

    return useMutation(toggleTPPCellLock, {
        onSuccess: async (data, variables) => {
            if (data) {
                queryClient.setQueryData<TppCell[]>(getTppCellsQueryKey(variables.tppId), (old) => {
                    if (!old) return []
                    return old.map((c) => (c._id === data._id ? { ...c, ...data } : c))
                })
            }
            invalidateTPPChangeLogQuery(variables.tppId)
            onSuccess?.()
        },
    })
}
